const QUERY_PARAM = "q"
const SHOPIFY_FILTERS = {
    availability: "filter.v.availability",
    price: {
        min: "filter.v.price.gte",
        max: "filter.v.price.lte"
    },
    refine_pn: "variants.sku:",
    description: "filter.p.m.custom.technical_specifications",
    brand: "filter.p.m.custom.brand"
};

const AVAILABILITY_VALUES = {
    "In Stock": 1,
    "Quote Eligible": 0,
};

const PRICE_DEFAULTS = {
    min: '0',
    max: '50000'
};

const filteringState = {
    price: null,
    availability: null,
    refine_pn: null,
    description: null,
    brand: null,
};

const SELECTORS = {
    rangeMin: 'input.price-range-min-input[type=number]',
    rangeMax: 'input.price-range-max-input[type=number]',
    radioChecked: 'input:checked',
    refinePartNumber: 'input.search-input-part_number',
    searchKeyword: 'input.search-input-keyword',
    checkboxChecked: 'input[type="checkbox"]:checked',
};

function extractSkuValue(query, prefix) {
    const match = query.match(/variants\.sku:(\S+)/);
    return match ? match[1] : "";
}

function removeSkuFromQuery(query, prefix) {
    const match = query.match(/variants\.sku:\S+/);
    if (!match) return query;
    
    return query.replace(/variants\.sku:\S+\s*/, '').trim();
}

const filterHandlers = {
    range: {
        get: (el) => {
            const min = el.querySelector(SELECTORS.rangeMin)?.value || null;
            const max = el.querySelector(SELECTORS.rangeMax)?.value || null;
            return (min || max) ? { min, max } : null;
        },
        set: (el, { min, max }) => {
            const minInput = el.querySelector(SELECTORS.rangeMin);
            const maxInput = el.querySelector(SELECTORS.rangeMax);
            if (minInput && min !== null) minInput.value = min;
            if (maxInput && max !== null) maxInput.value = max;
        }
    },
    radio: {
        get: (el) => ({
            value: el.querySelector(SELECTORS.radioChecked)?.value || null
        }),
        set: (el, { value }) => {
            const radio = el.querySelector(`input[value="${value}"]`);
            if (radio) radio.checked = true;
        }
    },
    refine: {
        get: (el) => ({
            value: el.querySelector(SELECTORS.refinePartNumber)?.value || ""
        }),
        set: (el, { value }) => {
            const refineInput = el.querySelector(SELECTORS.refinePartNumber);
            if (refineInput) refineInput.value = value;

            //refineInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
    },
    search: {
        get: (el) => ({
            value: el.querySelector(SELECTORS.searchKeyword)?.value || ""
        }),
        set: (el, { value }) => {
            const keywordEl = el.querySelector(SELECTORS.searchKeyword);
            if (keywordEl) keywordEl.value = value;
        }
    },
    select: {
        get: (el) => {
            const checked = Array.from(el.querySelectorAll(SELECTORS.checkboxChecked));
            const values = checked.map(cb => cb.value).filter(Boolean);
            return { value: values.length > 0 ? values.join(',') : null };
        },
        set: (el, { value }) => {
            if (!value) return;
            const values = value.split(',').map(v => v.trim());
            values.forEach(val => {
                const checkbox = el.querySelector(`input[value="${val}"]`);
                if (checkbox) checkbox.checked = true;
            });
        }
    }
};

const filterMappers = {
    price: {
        toState: (url) => {
            const min = url.searchParams.get(SHOPIFY_FILTERS.price.min);
            const max = url.searchParams.get(SHOPIFY_FILTERS.price.max);
            return (min || max) ? { min, max } : null;
        },
        toURL: (url, value) => {
            if (value?.min && value.min !== PRICE_DEFAULTS.min) {
                url.searchParams.set(SHOPIFY_FILTERS.price.min, value.min);
            }
            if (value?.max && value.max !== PRICE_DEFAULTS.max) {
                url.searchParams.set(SHOPIFY_FILTERS.price.max, value.max);
            }
        }
    },
    availability: {
        toState: (url) => {
            const value = url.searchParams.get(SHOPIFY_FILTERS.availability);
            if (!value) return null;
            const label = Object.keys(AVAILABILITY_VALUES).find(k => AVAILABILITY_VALUES[k] == value);
            return { value: label };
        },
        toURL: (url, value) => {
            if (value?.value) {
                url.searchParams.set(SHOPIFY_FILTERS.availability, AVAILABILITY_VALUES[value.value]);
            }
        }
    },
    refine_pn: {
        toState: (url) => {
            const q = url.searchParams.get(QUERY_PARAM);
            if (!q) return null;

            if (q.includes(SHOPIFY_FILTERS.refine_pn)) {
                const part_number = extractSkuValue(q, SHOPIFY_FILTERS.refine_pn);
                return { value: part_number };
            }
            return null;
        },
        toURL: (url, value) => {
            if (value?.value && value.value !== "") {
                const existingQ = url.searchParams.get(QUERY_PARAM) || "";
                const skuFilter = `${SHOPIFY_FILTERS.refine_pn}${value.value}`;
                const newQ = existingQ ? `${skuFilter} ${existingQ}` : skuFilter;
                url.searchParams.set(QUERY_PARAM, newQ);
            }
        }
    },
    description: {
        toState: (url) => {
            const query = url.searchParams.get(SHOPIFY_FILTERS.description);
            return query ? { value: query } : null;
        },
        toURL: (url, value) => {
            if (value?.value && value.value !== "") {
                url.searchParams.set(SHOPIFY_FILTERS.description, value.value);
            }
        }
    },
    brand: {
        toState: (url) => {
            const value = url.searchParams.get(SHOPIFY_FILTERS.brand);
            return value ? { value: value } : null;
        },
        toURL: (url, value) => {
            if (value?.value && value.value !== "") {
                const currentUrl = url.toString();
                const separator = currentUrl.includes('?') ? '&' : '?';
                const brandParam = `${SHOPIFY_FILTERS.brand}=${value.value}`;
                const regex = new RegExp(`[?&]${SHOPIFY_FILTERS.brand.replace(/\./g, '\\.')}=[^&]*`, 'g');
                const cleanUrl = currentUrl.replace(regex, '');
                url.href = cleanUrl + (cleanUrl.includes('?') ? '&' : '?') + brandParam;
            }
        }
}
};

const filters = [];

function syncFilter(filter) {
    const value = filterHandlers[filter.type].get(filter.el);
    filters
        .filter(f => f.name === filter.name && f.device !== filter.device)
        .forEach(f => filterHandlers[f.type].set(f.el, value));
}

function setUrlFilters(filterNames = []) {
    const url = new URL(window.location);
    
    clearFiltersFromUrl(url, filterNames);
    
    if (filterNames.length === 0) {
        Object.entries(filteringState).forEach(([key, value]) => {
            if (filterMappers[key]) {
                filterMappers[key].toURL(url, value);
            }
        });
    } else {
        filterNames.forEach(name => {
            const value = filteringState[name];
            if (filterMappers[name] && value) {
                filterMappers[name].toURL(url, value);
            }
        });
    }

    document.dispatchEvent(new CustomEvent('filters:apply', {
        detail: { filterNames, filteringState }
    }));

    window.location.href = url.toString();
}

function applyFilters(filter) {
    // apply manual filtering for price (!todo improve)
    if (filter.name === "price" || filter.name === "refine_pn") return;
    // manual filtering for all on mobile.
    if (window.innerWidth <= 900) return;
    
    setUrlFilters();
}

function clearFiltersFromUrl(url, filterNames = []) {
    const filtersToClear = filterNames.length === 0 ? Object.keys(SHOPIFY_FILTERS) : filterNames;
    
    filtersToClear.forEach(key => {
        if (key === 'refine_pn') {
            const q = url.searchParams.get(QUERY_PARAM);
            if (q) {
                const cleanQuery = removeSkuFromQuery(q, SHOPIFY_FILTERS.refine_pn);
                cleanQuery ? url.searchParams.set(QUERY_PARAM, cleanQuery) 
                           : url.searchParams.delete(QUERY_PARAM);
            }
        } else {
            const param = SHOPIFY_FILTERS[key];
            if (typeof param === 'object') {
                Object.values(param).forEach(p => url.searchParams.delete(p));
            } else {
                url.searchParams.delete(param);
            }
        }
    });
}

function clearFilters(filterNames = []) {
    const url = new URL(window.location);
    clearFiltersFromUrl(url, filterNames);
    window.location.href = url.toString();
}

function collectFilterElements() {
    document.querySelectorAll('[data-list-filter]').forEach(el => {
         // Check if this filter element is already collected
        const existingFilter = filters.find(f => f.el === el);
        if (existingFilter) return;
        
        const filter = {
            el,
            name: el.getAttribute('data-list-filter'),
            type: el.getAttribute('data-filter-type'),
            device: el.getAttribute('data-filter-device')?.trim()
        };
        
        filters.push(filter);
        
        el.querySelectorAll('input').forEach(input => {
            if (input.getAttribute('data-unwatch-input') === "true") return;
            input.addEventListener('change', () => {
                syncFilter(filter);
                setFilterInState(filter);
                applyFilters(filter);
            });
        });
    });
}

function initialize() {
    collectFilterElements();

    const url = new URL(window.location);
    
    Object.keys(filteringState).forEach(key => {
        if (filterMappers[key]) {
            const value = filterMappers[key].toState(url);
            if (value) filteringState[key] = value;
        }
    });
    
    filters.forEach(filter => {
        const stateValue = filteringState[filter.name];
        if (stateValue) {
            filterHandlers[filter.type].set(filter.el, stateValue);
        }
    });
}

function setFilterInState(filter){
    const value = filterHandlers[filter.type].get(filter.el);
    filteringState[filter.name] = value;
}

let buttonClickHandler = null;

function attachButtonsListener() {
    if (buttonClickHandler) {
        document.removeEventListener('click', buttonClickHandler);
    }
    buttonClickHandler = (e) => {
        const target = e.target.closest('[data-clear-filters-btn], [data-clear-one-filter], [data-apply-filters-btn], [data-apply-one-filter]');
        if (!target) return;

        const filterName = target.getAttribute('data-filter-ref');

        if (target.hasAttribute('data-clear-filters-btn') || target.hasAttribute('data-clear-one-filter')) {
            clearFilters(filterName ? [filterName] : []);
        } else {
            setUrlFilters(filterName ? [filterName] : []);
        }
    };
    document.addEventListener('click', buttonClickHandler);
}

function reinitializeModal() {
    collectFilterElements();
    attachButtonsListener();
    
    filters.forEach(filter => {
        const stateValue = filteringState[filter.name];
        if (stateValue) {
            filterHandlers[filter.type].set(filter.el, stateValue);
        }
    });
}

initialize();
attachButtonsListener();

window.filters = filters;
window.filteringState = filteringState;
document.dispatchEvent(new CustomEvent('filters_initialized'));
//document.addEventListener('modal_opened', () => reinitializeModal());